/**
 * Basket Domain Errors
 *
 * Typed errors for basket operations.
 * Allows for precise error handling in use cases and UI.
 */

export type BasketErrorCode =
  | 'ADD_FAILED'
  | 'SYNC_FAILED'
  | 'DELETE_FAILED'
  | 'PRODUCT_NOT_AVAILABLE'
  | 'QUANTITY_EXCEEDED'
  | 'UNKNOWN'

export class BasketError extends Error {
  readonly code: BasketErrorCode
  readonly cause?: unknown

  constructor(code: BasketErrorCode, cause?: unknown) {
    super(BasketError.getMessageForCode(code))
    this.name = 'BasketError'
    this.code = code
    this.cause = cause
  }

  private static getMessageForCode(code: BasketErrorCode): string {
    const messages: Record<BasketErrorCode, string> = {
      ADD_FAILED: 'Failed to add item to basket',
      SYNC_FAILED: 'Failed to synchronize basket',
      DELETE_FAILED: 'Failed to delete item from basket',
      PRODUCT_NOT_AVAILABLE: 'Product is not available',
      QUANTITY_EXCEEDED: 'Requested quantity exceeds availability',
      UNKNOWN: 'Unknown basket error',
    }
    return messages[code]
  }
}
